import {PlannedAccessesFormSections} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-sections/PlannedAccessesFormSections'
import {PlannedAccessesFormHeading} from '@/features/planned-accesses/components/accesses-form/planned-accesses-form-heading/PlannedAccessesFormHeading'
import {CreatePlannedAccessFormValidationSchema} from '@/features/planned-accesses/formSchemas'
import {CreatePlannedAccessesConfirmationDialog} from '@/features/planned-accesses/components/accesses-form/create-planned-accesses-confirmation-dialog/CreatePlannedAccessesConfirmationDialog'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {BannerAlert} from '@/components/commons/banner-alert/BannerAlert'
import {useToggle} from '@/hooks/useToggle'
import {useTranslation} from '@/translations/i18n'
import {useRef, useState} from 'react'
import {useDialogStore} from '@ariakit/react'
import {Divider} from '@/components/ui/divider/Divider'
import {useFormContext} from 'react-hook-form'
import {WarningBanner} from '@/components/commons/warning-banner/WarningBanner'

export const CreatePlannedAccessesFormCard = ({isMissingExpirationDate}: {isMissingExpirationDate: boolean}) => {
    const {t} = useTranslation()
    const viewportRef = useRef<HTMLDivElement>(null)

    const {getValues} = useFormContext<CreatePlannedAccessFormValidationSchema>()

    const {isActive: isErrorBannerVisible, on: showErrorBanner, off: dismissErrorBanner} = useToggle()
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false)
    const confirmationDialogStore = useDialogStore({
        open: isConfirmationDialogOpen,
        setOpen: setIsConfirmationDialogOpen
    })
    const errorBannerRef = useRef<HTMLDivElement>(null)

    const onFailedSubmission = () => {
        showErrorBanner()
        confirmationDialogStore.setOpen(false)
        if (viewportRef.current) {
            viewportRef.current.scrollTo({top: 0, behavior: 'smooth'})
        }
    }

    return (
        <PageCardWrapper>
            <PlannedAccessesFormHeading
                title={t('planned_accesses:create_form_title')}
                schema={CreatePlannedAccessFormValidationSchema}
                showConfirmationDialog={() => confirmationDialogStore.setOpen(true)}
                onError={onFailedSubmission}
                isMissingExpirationDate={isMissingExpirationDate}
            />
            <Divider direction="horizontal" />
            <PageContent padding={0}>
                {isMissingExpirationDate ? (
                    <div style={{padding: 16}}>
                        <WarningBanner
                            title={t('agenda:access_missing_expiration_date')}
                            subtitle={t('agenda:access_missing_expiration_date_subtitle')}
                            maxWidth="unset"
                        />
                    </div>
                ) : (
                    <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />} viewportProps={{ref: viewportRef}}>
                        {isErrorBannerVisible && (
                            <>
                                <BannerAlert ref={errorBannerRef} onClose={dismissErrorBanner} />
                                <Divider direction="horizontal" />
                            </>
                        )}
                        <PlannedAccessesFormSections />
                    </ScrollArea>
                )}
            </PageContent>
            {isConfirmationDialogOpen && (
                <CreatePlannedAccessesConfirmationDialog
                    dialogStore={confirmationDialogStore}
                    onError={onFailedSubmission}
                    defaultValues={getValues()}
                />
            )}
        </PageCardWrapper>
    )
}
